import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Observable } from 'rxjs';

import { Offer } from 'graphql/models/extended';
import { OfferBase } from 'models/offer.model';
import { OfferService } from 'shared/services/offer.service';
import { StoreService } from 'shared/services/store.service';

import { ExpirationDateComponent } from '../expiration-date.component';

@Component({
  selector: 'app-expiration-date-modal',
  templateUrl: './expiration-date-modal.component.html',
  styleUrls: ['./expiration-date-modal.component.scss']
})
export class ExpirationDateModalComponent implements OnInit {
  @ViewChild(ExpirationDateComponent) expirationDateComponent!: ExpirationDateComponent;

  offer!: OfferBase;

  get form(): UntypedFormGroup {
    return this.expirationDateComponent.form;
  }

  get newExpirationDate(): string {
    return this.expirationDateComponent.newExpirationDate.toISOString();
  }

  constructor(
    private storeService: StoreService,
    private offerService: OfferService
  ) { }

  ngOnInit(): void {
    this.init();
  }

  private init(): void {
    this.storeService.getCurrentOffer()
      .subscribe((data: OfferBase) => {
        this.offer = data || {};
      });
  }

  onFooterLinkFunction(): void {
    this.expirationDateComponent.resetDuration();
  }

  onSubmit(): Observable<Offer> {
    return this.offerService.updateOfferExpiration(
      this.offer,
      this.newExpirationDate
    );
  }
}
